<template>
  <div class="step-box">
    <div class="step-scroll">
      <div style="margin: 0 20px">
        <div class="step-sign">
          <div v-for="(item, index) in stepList" :key="index" :style="{ width: item.blockWidth + 'px' }" class="sign-block">
            <div class="sign-block-item">
              <div class="block-item-num" :class="{'block-item-num-gray': !item.actived}">{{ item.blockNum }}</div>
              <div class="block-item-img">
                <img :src="item.actived ? require('@/assets/images/beer_red.png') : require('@/assets/images/beer_gray.png')" />
              </div>
              <div class="block-item-icon">
                <img :src="item.actived ? require('@/assets/images/down_red.png') : require('@/assets/images/down_gray.png')" />
              </div>
            </div>
          </div>
        </div>
        <div class="step-row" :style="{ width: totalWidth + 'px' }">
          <div class="step-row-rate" :style="{ width: completedWidth + 'px' }"></div>
        </div>
      </div>
      <div class="step-completed" :style="{ width: completedWidth + 'px' }">
        <div class="step-mark">
          <div class="step-mark-icon">
            <img src="@/assets/images/up.png" />
          </div>
          <div class="step-mark-num">{{ tradeApplyExecPboDTO.completePoint }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tradeApplyExecPboDTO: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      frontNum: null,
      frontWidth: null,
      stepList: [],
      totalWidth: '',
      completedWidth: ''
    }
  },
  mounted () {
    this.setStepInfo()
  },
  methods: {
    setStepInfo () {
      const stepWidth = 90

      this.totalWidth = this.tradeApplyExecPboDTO.stageNumber * stepWidth
      this.completedWidth = this.tradeApplyExecPboDTO.completePoint / this.tradeApplyExecPboDTO.totalSalePoint * this.totalWidth

      // 除最后一个阶段的每个阶段点数
      this.frontNum = parseInt(this.tradeApplyExecPboDTO.totalSalePoint / this.tradeApplyExecPboDTO.stageNumber)
      // 除最后一个阶段的每个阶段长度
      this.frontWidth = this.totalWidth / this.tradeApplyExecPboDTO.totalSalePoint * this.frontNum
      for (let i = 0; i < this.tradeApplyExecPboDTO.stageNumber; i++) {
        this.stepList.push({
          actived: false,
          blockWidth: this.frontWidth,
          blockNum: null
        })
      }
      this.stepList.forEach((item, index) => {
        if (index === this.stepList.length - 1) {
          item.blockNum = this.tradeApplyExecPboDTO.totalSalePoint
          item.blockWidth = this.totalWidth - this.frontWidth * (this.stepList.length - 1)
        } else {
          item.blockNum = (index + 1) * this.frontNum
        }
        item.actived = item.blockNum <= this.tradeApplyExecPboDTO.completePoint
      })
    }
  }
}
</script>

<style lang="scss">
.step-box {
  padding-top: 10px;
  width: 100%;
  // height: 150px;
  position: relative;
  box-sizing: border-box;

  .step-scroll {
    // margin: auto;
    overflow-x: auto;
    // &::-webkit-scrollbar {
    //   width: 0;
    //   height: 0;
    //   color: transparent;
    //   display: none;
    // }

    .step-sign {
      display: flex;

      .sign-block {
        flex-shrink: 0;
        height: 90px;
        box-sizing: border-box;
        position: relative;
        z-index: 10;
      }

      .sign-block-item {
        width: 45px;
        box-sizing: border-box;
        position: absolute;
        right: -22px;

        div {
          margin: auto
        }

        .block-item-num {
          text-align: center;
          font-size: 18px;
          color: $base-red;
          border-radius: 6px;
          border: 1px dashed $base-red;
        }

        .block-item-num-gray {
          color: $font-c-9;
          border: 1px dashed $font-c-9;
        }

        .block-item-img {
          // width: 55px;
          // height: 55px;
          margin-top: 5px;
        }

        .block-item-icon {
          width: 30px;
          height: 30px;
          margin-top: -8px;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }
    }

    .step-row {
      height: 30px;
      margin-top: 5px;
      overflow: hidden;
      border-radius: 35px;
      background-color: #f0f0f0;
      box-sizing: border-box;
      box-shadow: 0px 0px 10px #ccc inset;

      .step-row-rate {
        height: 30px;
        background-color: $base-red;
        position: relative;
      }
    }

    .step-completed {
      height: 80px;
      position: relative;

      .step-mark {
        text-align: center;
        width: 100px;
        padding-top: 5px;
        box-sizing: border-box;
        position: absolute;
        right: -70px;

        .step-mark-icon {
          width: 25px;
          height: 30px;
          margin: auto;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .step-mark-num {
          display: inline-block;
          padding: 2px 8px;
          font-size: 16px;
          color: $base-red;
          border-radius: 6px;
          border: 1px dashed $base-red;
        }
      }
    }
  }
}
</style>
